import { DocumentItem } from "../../models/polymer/Document.model";
import data from "./options.json";

export const shared_documents_list: DocumentItem[] = data.documents;
